import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { useSponsorshipVoucherFormModal } from 'modules/auth/modals/useSponsorshipVoucherFormModal'
import {
  IconChevronRight,
  IconGift,
} from 'modules/common/components/_icons/icons'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'

export const AddSponsorshipVoucherButton = () => {
  const { t } = useTranslation('auth-components')

  const { showModal: showSponsorshipVoucherFormModal } =
    useSponsorshipVoucherFormModal()

  const onClick = () => {
    trackEvent({ eventType: EnumAuthTrackingEvents.SIGNUP_ENTER_VOUCHER_CODE })
    showSponsorshipVoucherFormModal()
  }

  return (
    <button
      className="flex w-full items-center justify-between space-x-4 rounded-xl border border-info-100 p-4"
      onClick={onClick}
      type="button"
    >
      <IconGift className="h-8 w-8 shrink-0 rounded-lg bg-primary-90 p-1 text-primary" />
      <span className="w-full grow text-left font-bold">
        {t('addSponsorshipVoucherButton.label')}
      </span>
      <IconChevronRight className="my-1.5 shrink-0" />
    </button>
  )
}
